import httpHubless from 'hub-http/clients/noPortalApiClient';
import Endpoints from '../constants/apiEndpoints';
export const fetchPasskeys = () => httpHubless.get(Endpoints.PASSKEY_SETTINGS);
export const initiatePasskey = (email = '') => httpHubless.post(Endpoints.PASSKEY_INITIATE, {
  data: {
    email
  }
});
export const validatePasskey = requestData => httpHubless.post(Endpoints.PASSKEY_VALIDATE, {
  data: requestData
});